import { api } from './index';

const ActionRequestService = {
  get(id, params) {
    return api.get('actions/' + id, params);
  },
  create(params) {
    return api.post('actions/', params);
  },
  update(id, params) {
    return api.post('actions/' + id, params);
  },
  getByArea(area_id, params) {
    return api.get('actions/by-area/' + area_id, params);
  },
  getByAreaFunds(area_id, params) {
    return api.get('actions/by-area-funds/' + area_id, params);
  },
  getFlow(flow) {
    return api.get('flows/' + flow);
  },
  getBusinessUnities(params) {
    return api.get('business-unities/', params);
  },
  getCategories(params) {
    return api.get('categories/', params);
  },
  amountByStatus(params){
    return api.get('actions/amount-by-status/', params);
  },
  deleteFile(id){
    return api.delete('files/'+id);
  }
};

export default ActionRequestService;